const filterConfig = {
    moviesAndProgramsMapping: [
        {name: 'Both RoVi & TMS IDs', code: 'linkedRoviAndTmsIds'},
        {name: 'TiVo only', code: 'linkedRovi'},
        {name: 'GN only', code: 'linkedTmsID'},
        {name: 'Source ID only', code: 'linkedSourceID'},
        {name: 'RoVi, source ID & TMS IDs absent', code: 'noRoviNoTmsNoSourceId'},
        {name: 'All records', code: 'linkedNot'},
    ],
};

export default filterConfig;
